module.exports = __webpack_public_path__ + "static/media/20ECE16.fe8f68ee.jpg";